import {
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SectionsStylesEditor from "./configurationSyles/SectionsStylesEditor";

const DocumentStylesEditor = ({ onBack, nameDocument, idDocument, token }) => {

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        p={2}
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
          borderRadius: 2,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Tooltip title="Volver" arrow>
            <IconButton
              onClick={onBack}
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
                boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "text.primary",
              letterSpacing: 0.5,
            }}
          >
            Edición de estilos del documento por seciones
          </Typography>
        </Box>
      </Box>

      <SectionsStylesEditor token={token} idDocument={idDocument} />

    </Box>
  );
};

export default DocumentStylesEditor;
